export default "__VITE_ASSET__86d0e543__"